/**
 * Debug utility for development-only logging
 * Replaces console.log with a utility that only logs in development mode
 */

const isDevelopment = process.env.NODE_ENV === "development";

/**
 * Logs messages only in development mode
 * @param message - The message to log
 * @param optionalParams - Additional parameters to log
 */
export function debug(message?: any, ...optionalParams: any[]): void {
  if (isDevelopment) {
    console.log(message, ...optionalParams);
  }
}

/**
 * Logs info messages only in development mode
 * @param message - The message to log
 * @param optionalParams - Additional parameters to log
 */
export function debugInfo(message?: any, ...optionalParams: any[]): void {
  if (isDevelopment) {
    console.info(message, ...optionalParams);
  }
}

/**
 * Logs warning messages only in development mode
 * @param message - The message to log
 * @param optionalParams - Additional parameters to log
 */
export function debugWarn(message?: any, ...optionalParams: any[]): void {
  if (isDevelopment) {
    console.warn(message, ...optionalParams);
  }
}

/**
 * Logs error messages (always logged, even in production)
 * @param message - The message to log
 * @param optionalParams - Additional parameters to log
 */
export function debugError(message?: any, ...optionalParams: any[]): void {
  console.error(message, ...optionalParams);
}

/**
 * Logs table data only in development mode
 * @param data - The data to display in table format
 */
export function debugTable(data?: any): void {
  if (isDevelopment) {
    console.table(data);
  }
}

/**
 * Groups log messages only in development mode
 * @param label - The label for the group
 */
export function debugGroup(label: string): void {
  if (isDevelopment) {
    console.group(label);
  }
}

/**
 * Ends a log group only in development mode
 */
export function debugGroupEnd(): void {
  if (isDevelopment) {
    console.groupEnd();
  }
}
